var Region = /** @class */ (function () {
    function Region(obj, id) {
        if (id) {
            this.id = id;
        }
        this.bg_name = obj.bg_name;
        this.en_name = obj.en_name;
        if (obj.position) {
            this.position = obj.position;
        }
    }
    Object.defineProperty(Region.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Region.prototype, "BgName", {
        get: function () {
            return this.bg_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Region.prototype, "EnName", {
        get: function () {
            return this.en_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Region.prototype, "Position", {
        get: function () {
            return this.position;
        },
        enumerable: false,
        configurable: true
    });
    return Region;
}());
export { Region };
export function createRegion(obj, id) {
    return new Region(obj, id);
}
export function createRegions(rawMRegions) {
    var regions = [];
    var rawRegionsData = rawMRegions.data;
    for (var _i = 0, rawRegionsData_1 = rawRegionsData; _i < rawRegionsData_1.length; _i++) {
        var rawRegion = rawRegionsData_1[_i];
        var region = createRegion(rawRegion.attributes, rawRegion.id);
        regions.push(region);
    }
    return regions;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/region/region.ts
// module id = 126
// module chunks = 0